// extracted by mini-css-extract-plugin
export default {"highload":"SwipeCheckbox_highload__cSVfV","lb":"SwipeCheckbox_lb__dFOmK","lb1":"SwipeCheckbox_lb1__OTxVV"};